import { InjectionToken } from '@angular/core';

export interface EnvConfig {
    coreApiUrl: string;
    oidcAuthority: string;
    oidcRedirectUri: string;
    oidcPostLogoutRedirectUri: string;
    oidcRealm: string;
    oidcClientId: string;
    /** OpenWeather API key. The topbar weather chip is hidden when absent. */
    weatherApiKey?: string;
    /** OpenWeather city query, e.g. "London,GB". Falls back to London. */
    weatherCity?: string;
    /** CARTO basemap API key (carto.com/basemaps/apikey — free up to a fair-use
     *  limit). Unlike weatherApiKey, there's no graceful "just hide it" fallback
     *  when absent — every Leaflet map in the app (Monitor's fleet map, device
     *  overview, add/edit device) renders CARTO tiles, so a missing key means
     *  those tiles fail to load, not that a widget disappears. */
    cartoApiKey?: string;
}

export const ENV_CONFIG = new InjectionToken<EnvConfig>('ENV_CONFIG');
